export default "__VITE_ASSET__O6EL4BHC__"